// extracted by mini-css-extract-plugin
export var card = "InfoCard-module--card--+r-SR";
export var cardDescription = "InfoCard-module--cardDescription--AVG57";
export var cardIcon = "InfoCard-module--cardIcon--SJNfM";
export var cardTitle = "InfoCard-module--cardTitle--xHvx7";
export var cardsGrid = "InfoCard-module--cardsGrid--hYEE4";
export var cardsWrapper = "InfoCard-module--cardsWrapper--FjJ6A";
export var fourColumns = "InfoCard-module--fourColumns--pqbYI";
export var iconCenter = "InfoCard-module--iconCenter--hNpxP";
export var iconImage = "InfoCard-module--iconImage--vf1ul";
export var noIcon = "InfoCard-module--noIcon--P8T7P";
export var threeColumns = "InfoCard-module--threeColumns--O32Xf";